/**
 * FilterChipsBar — «Все / Фото / Видео» на /gallery (Phase 4).
 *
 * Always visible as the top filter row on /gallery.
 *
 * Props:
 *  - value    ('all' | 'photo' | 'video')
 *  - onChange (fn(newValue))
 */
import { useTranslation } from 'react-i18next';
import { Chip } from '../primitives';
import { hapticSelection } from '../../utils/haptics';

const FILTERS = [
  { value: 'all', labelKey: 'gallery.filterAll' },
  { value: 'photo', labelKey: 'gallery.filterPhoto' },
  { value: 'video', labelKey: 'gallery.filterVideo' },
];

export default function FilterChipsBar({ value, onChange, loading }) {
  const { t } = useTranslation();
  return (
    <div
      className="flex gap-2 px-body-x"
      data-testid="gallery-filter-chips"
      role="tablist"
      aria-label={t('gallery.filterLabel')}
      aria-busy={loading ? 'true' : undefined}
    >
      {FILTERS.map((f) => (
        <Chip
          key={f.value}
          selected={value === f.value}
          onClick={() => {
            if (f.value !== value) hapticSelection();
            onChange(f.value);
          }}
          data-testid={`filter-chip-${f.value}`}
          role="tab"
          aria-selected={value === f.value}
        >
          {t(f.labelKey)}
        </Chip>
      ))}
    </div>
  );
}
